var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1137",
    "data-name": "Raggruppa 1137",
    transform: "translate(-382 -465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1126",
    "data-name": "Raggruppa 1126",
    transform: "translate(-313 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1125",
    "data-name": "Raggruppa 1125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1124",
    "data-name": "Raggruppa 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1123",
    "data-name": "Raggruppa 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1122",
    "data-name": "Raggruppa 1122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_584",
    "data-name": "Rettangolo 584",
    width: 16,
    height: 19,
    rx: 1,
    transform: "translate(695 457)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_44",
    "data-name": "Tracciato 44",
    d: "M446.908,188.966a.793.793,0,0,1,1.052,0l5.255,4.8a.639.639,0,0,1,0,.961.8.8,0,0,1-1.052,0l-3.985-3.64v9.559a.747.747,0,0,1-1.489,0v-9.559l-3.985,3.64a.8.8,0,0,1-1.052,0,.637.637,0,0,1,0-.961Z",
    transform: "translate(1150.434 660.296) rotate(180)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_585",
    "data-name": "Rettangolo 585",
    width: 12,
    height: 2,
    rx: 1,
    transform: "translate(384 480.03)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/DOWNLOAD.7f9f0e6582464eb0372cdb9f0b6ad434.svg";
export { ForwardRef as ReactComponent };